import { useEffect, useRef, useState } from 'react';
import { trackEvent } from '../utils/analytics';

const STORAGE_KEY = 'interestPromptSeen';

const hasSeenPrompt = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const rememberPrompt = () => {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    // The ref still prevents repeats during this visit if storage is blocked.
  }
};

export default function useInterestPrompt({ loggedIn, uiReady, sharedFilterPresent }) {
  const [showInterestPrompt, setShowInterestPrompt] = useState(false);
  const handledRef = useRef(false);
  const deadlineRef = useRef(Date.now() + 6500);

  useEffect(() => {
    // Existing users already know the site; keep this record after logout.
    if (loggedIn) {
      handledRef.current = true;
      rememberPrompt();
      setShowInterestPrompt(false);
      return undefined;
    }

    if (!uiReady || sharedFilterPresent || handledRef.current || hasSeenPrompt()) {
      return undefined;
    }

    const timeout = setTimeout(() => {
      // Another tab may have displayed the prompt while this timer was pending.
      if (hasSeenPrompt()) return;
      handledRef.current = true;
      rememberPrompt();
      setShowInterestPrompt(true);
      trackEvent('interest_prompt_show', { target: 'quick_topics' });
    }, Math.max(0, deadlineRef.current - Date.now()));

    return () => clearTimeout(timeout);
  }, [loggedIn, uiReady, sharedFilterPresent]);

  return [showInterestPrompt, setShowInterestPrompt];
}
